module.exports = __webpack_public_path__ + "img/syukyaku-top-pa001.836e985f.png";